export default __webpack_public_path__ + "static/media/facebook.4d1a4efd.svg";